import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

// -------- Contact --------
export const submitContact = (payload) => api.post('/contact', payload).then((r) => r.data);

// -------- Case studies --------
export const fetchCaseStudies = () => api.get('/case-studies').then((r) => r.data);

// -------- Microsites --------
export const fetchMicrosites = () => api.get('/microsites').then((r) => r.data);
